// extracted by mini-css-extract-plugin
export default {"mainWrapper":"international-non-consolidation_mainWrapper__lK9M7","actionButtons":"international-non-consolidation_actionButtons__s3i7Y"};